import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// Performance monitoring disabled for production
// Uncomment below to enable web vitals monitoring
// import reportWebVitals from './reportWebVitals';
// reportWebVitals(console.log);
